"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "NotificationContainer", {
  enumerable: true,
  get: function get() {
    return _NotificationContainer.default;
  }
});
Object.defineProperty(exports, "NotificationManager", {
  enumerable: true,
  get: function get() {
    return _NotificationManager.default;
  }
});
Object.defineProperty(exports, "Notifications", {
  enumerable: true,
  get: function get() {
    return _Notifications.default;
  }
});
exports.default = void 0;

var _Notifications = _interopRequireDefault(require("./Notifications.js"));

var _NotificationContainer = _interopRequireDefault(require("./NotificationContainer"));

var _NotificationManager = _interopRequireDefault(require("./NotificationManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _Notifications.default;
exports.default = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-notifications/lib/index.js
 ** module id = 28
 ** module chunks = 0
 **/